import APIService from 'api/APIService'
import { useQuery } from 'react-query'
import { useMemo } from 'react'
import { UnitActiveCustomer } from 'types/unit'
import { useSettings } from 'core/hooks/useSettings'
import useCurrentTeam from 'core/hooks/useCurrentTeam'
import { useUserProfile } from 'core/hooks/useDataHook'

interface UseWalletReturn {
  isLoading: boolean
  hasWallet: boolean
  wallet?: UnitActiveCustomer
  balance: number
}

const useWallet = (includeBalance = false): UseWalletReturn => {
  const {
    data: {
      featureFlags: { ENABLE_EVERLANCE_PAYMENTS }
    }
  } = useSettings()
  const { data: currentUser } = useUserProfile()

  const { data: team } = useCurrentTeam()
  const team_token_id = team?.token_id

  const { data, isLoading } = useQuery(
    ['unit', 'wallet'],
    () =>
      APIService.unit.unitGetTeamCustomer({
        team_token_id: String(team_token_id),
        scope: 'read'
      }),
    {
      enabled: ENABLE_EVERLANCE_PAYMENTS && !!team_token_id
    }
  )

  const { data: walletWithBalance, isLoading: isLoadingWithBalance } = useQuery(
    ['unit', 'wallet', 'withBalance'],
    () => APIService.unit.unitGetCurrentUserActiveCustomer(includeBalance),
    {
      enabled: includeBalance
    }
  )

  const balance = useMemo(() => {
    return walletWithBalance?.unit_account.balance ?? 0
  }, [walletWithBalance])

  if (ENABLE_EVERLANCE_PAYMENTS && data) {
    return {
      isLoading: isLoading || isLoadingWithBalance,
      hasWallet: !!currentUser?.team_has_everpay_enabled,
      wallet: data,
      balance: isNaN(balance) ? balance : balance / 100
    }
  }
  return {
    isLoading: isLoading || isLoadingWithBalance,
    hasWallet: false,
    wallet: undefined,
    balance: 0
  }
}

export default useWallet
